"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var data_service_1 = __importDefault(require("../../services/data.service"));
var loading_1 = __importDefault(require("../shared/loading"));
var web_view_service_1 = __importDefault(require("../../services/web-view.service"));
var lang_service_1 = __importDefault(require("../../services/lang.service"));
var ComicList = function (props) {
    var _a = (0, react_1.useState)(undefined), comicList = _a[0], setComicList = _a[1];
    var getLabel = lang_service_1.default.getLabel;
    var getComicList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var comics;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, data_service_1.default.getComics()];
                case 1:
                    comics = _a.sent();
                    setComicList(comics);
                    return [2];
            }
        });
    }); };
    var goToComic = function (comic) {
        props.history.push("/".concat(comic.slug, "/"));
    };
    var renderComic = function (comic) { return (react_1.default.createElement("div", { key: comic.id, className: "comic-list-item", onClick: function () { return goToComic(comic); } },
        react_1.default.createElement("div", { className: "comic-list-item__bgnd", style: { backgroundImage: "url(\"".concat(comic.media.poster, "\")") } },
            react_1.default.createElement("div", { className: "comic-list-item__content" },
                react_1.default.createElement("div", { className: "comic-list-item__title-container" },
                    react_1.default.createElement("img", { className: "comic-list-item__title", src: comic.media.title })),
                react_1.default.createElement("div", { className: "comic-list-item__description-big" },
                    react_1.default.createElement("p", null, getLabel(comic.about, true))))),
        react_1.default.createElement("div", { className: "comic-list-item__description-phone" },
            react_1.default.createElement("p", null, getLabel(comic.shortDesc, true))))); };
    (0, react_1.useEffect)(function () {
        if (web_view_service_1.default.isWebView()) {
            web_view_service_1.default.sendEvent({ name: 'reachedComicList' });
        }
        getComicList();
    }, []);
    if (!comicList)
        return react_1.default.createElement(loading_1.default, null);
    if (!comicList.length)
        return react_1.default.createElement("p", null, "There are no comics");
    return (react_1.default.createElement("div", { className: "comic-list" },
        react_1.default.createElement("h2", { className: "comic-list__title" }, getLabel('featured')),
        react_1.default.createElement("div", { className: "comic-list__list-wrapper" }, comicList.map(renderComic))));
};
exports.default = ComicList;
